module.exports = __webpack_public_path__ + "img/5.2c92a3fb.png";